import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { NavArrowButton } from './NavArrowButton';
const addMonths = (date, delta) => new Date(date.getFullYear(), date.getMonth() + delta, 1);
const formatMonth = (date) => date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
export const SummaryHeaderTitle = ({ date, onDateChange, backDisabled, fwdDisabled, }) => {
    return (<View style={styles.container}>
      <Text style={styles.title}>Summary</Text>
      <View style={styles.navGroup}>
        <NavArrowButton direction="back" disabled={backDisabled} onPress={() => onDateChange(addMonths(date, -1))}/>
        <Text style={styles.dateText}>{formatMonth(date)}</Text>
        <NavArrowButton direction="forward" disabled={fwdDisabled} onPress={() => onDateChange(addMonths(date, 1))}/>
      </View>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
    },
    title: { fontSize: 17, fontWeight: '600' },
    navGroup: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    dateText: { fontSize: 16, fontWeight: '600' },
});
